import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { QuillEditor } from "../../utils/quill-editor";
import { Formik } from "formik";
import { Button } from "@mui/material";
import { toast } from "react-hot-toast";

export default function OfferNotes({ offer, formik, onAutoSave }) {
  const { t } = useTranslation();
  const [notes, setNotes] = useState(offer?.notes || "");

  useEffect(() => {
    if (offer?.notes !== undefined) {
      setNotes(offer.notes);
    }
  }, [offer?.notes]);

  const handleNotesChange = (value) => {
    setNotes(value);
    formik.setFieldValue("notes", value);
    // Auto-save after a delay
    setTimeout(() => {
      onAutoSave();
    }, 2000);
  };

  return (
    <div className="bg-white shadow-sm rounded-lg">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">
          Notater
        </h3>
        <p className="text-sm text-gray-500 mt-1">
          Skriv dine tanker og notater om dette tilbudet. Disse er kun synlige internt.
        </p>
      </div>
      <div className="px-6 py-6">
        <QuillEditor
          name="notes"
          value={notes}
          onChange={handleNotesChange}
          placeholder="Skriv dine notater her..."
          rows={12}
        />
      </div>
    </div>
  );
}


